import React, { useState } from 'react';

import { SqlDebugModal } from '@/components/reports/sql-debug-modal';
import { IconButton } from '@/components/ui';
import { useFeatureFlags } from '@/hooks/use-feature-flags';

export interface DebugSqlButtonProps {
	debugSqlPath: string;
	reportTitle: string;
}

export const DebugSqlButton: React.FC<DebugSqlButtonProps> = ({ debugSqlPath, reportTitle }) => {
	const [visible, setVisible] = useState(false);
	const { hasFlag } = useFeatureFlags();
	if (!hasFlag('sql_admin')) return null;

	return (
		<>
			<IconButton
				icon="code-slash-outline"
				size={22}
				iconColor="#1976d2"
				onPress={() => setVisible(true)}
				accessibilityLabel="Debug SQL"
				testID="report-action-debug-sql"
			/>
			<SqlDebugModal
				visible={visible}
				onDismiss={() => setVisible(false)}
				apiPath={debugSqlPath}
				reportTitle={reportTitle}
			/>
		</>
	);
};
